import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function detectUnitSystem(): 'imperial' | 'metric' {
  if (typeof navigator !== 'undefined') {
    const lang = navigator.language || '';
    const locales = navigator.languages || [];
    if (lang.startsWith('en-US') || locales.some(l => l.startsWith('en-US'))) return 'imperial';
    if (navigator.userAgent.includes('Windows NT') && lang.startsWith('en')) return 'imperial';
    // Some browsers expose region
    // @ts-ignore
    if (navigator?.userLanguage?.startsWith('en-US')) return 'imperial';
  }
  return 'metric';
} 